import {
  Text as MantineText,
  TextProps as MantineTextProps,
  PolymorphicComponentProps,
} from "@mantine/core";
import React, { ReactNode } from "react";

import { useResponsiveValue } from "@contexts";

type ResponsiveValue<T> =
  | T
  | {
      base?: T;
      xs?: T;
      sm?: T;
      md?: T;
      lg?: T;
      xl?: T;
    };

export interface ExtendedTextProps
  extends Omit<MantineTextProps, "size" | "children"> {
  size?: ResponsiveValue<MantineTextProps["size"]>;
  children?: ResponsiveValue<ReactNode>;
}

export type TextProps<C = "p"> = PolymorphicComponentProps<
  C,
  ExtendedTextProps
>;

export const Text = React.forwardRef<HTMLParagraphElement, TextProps>(
  ({ size, children, ...props }, ref) => {
    const resolvedSize = useResponsiveValue(size);
    const resolvedChildren = useResponsiveValue(children);

    return (
      <MantineText ref={ref} size={resolvedSize} {...props}>
        {resolvedChildren}
      </MantineText>
    );
  }
) as <C = "p">(props: TextProps<C>) => React.ReactElement;
